import React from 'react';
import { PanelRightOpen } from 'lucide-react';
import styles from '../../styles/chat-history.module.css';
import { useTranslation } from 'react-i18next';

const ChatHistoryBtn = ({ role, isMobile, isChatOpen, onChatHistoryClicks }) => {
  const { t } = useTranslation(['chat']);

  return (
    <>
      {(
        role === 'consumer' ||
        role === 'loanOfficer' ||
        role === 'organization' ||
        role === 'branchAdmin' ||
        role === 'superAdmin' ||
        role === 'loanProcessor'
      ) && (
        <div className={styles.historyButtonWrap}>
          <button
            className={`${styles.historyButton} ${
              isMobile ? styles.historyButtonMobile : ''
            } ${isChatOpen ? styles.historyButtonActive : ''}`}
            onClick={() => onChatHistoryClicks()}
            onFocus={(e) => e.target.blur()}
            tabIndex={-1}
            aria-label={t('chat:history.button')}
          >
            {isMobile ? (
              <PanelRightOpen className={styles.historyButtonIconMobile} />
            ) : (
              <span
                className={`${styles.historyButtonText} ${
                  isMobile ? styles.historyButtonTextMobile : ''
                }`}
              >
                {t('chat:history.button')}
              </span>
            )}
          </button>
        </div>
      )}
    </>
  );
};
export default ChatHistoryBtn;
